export default __webpack_public_path__ + "5b2e644b776e78b44b1ba077890f0012.png";